import { Component, Injector } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SearchDialogComponent } from '@Work/Accounts/proprietary/controls/search-dialog.component';
import { AppService } from '@Core/services/proprietary/app.service';
import { DataService } from '@Core/services/proprietary/data.service';

@Component({
    standalone: false,
    selector: 'provider-search-dialog',
    templateUrl: './provider-search-dialog.component.html',
    providers: [DataService]
})
export class ProviderSearchDialogComponent extends SearchDialogComponent {
    constructor(private injector: Injector, private activeModal: NgbActiveModal, public app: AppService) {
        super(injector);
    }

    initialize(): boolean {
        this.parentActiveModal = this.activeModal;
        //ask about icon / data-initials
        this.objectType = 'Provider';
        this.model.title = 'Select Provider';

        this.model.criteria.Max = this.model.currentOptions.maxRows;

        if (!this.model.criteria.View) {
            this.model.criteria.View = 'Full';
        }

        return true;
    }
}
